import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'movieBanner'
})

export class MovieBannerPipe implements PipeTransform {
    transform(value: any): any {
        return `http://developer.tmsimg.com/${value}?api_key=9h6jvc6de4ez8xwy53khs5bw`
    }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/movies/shared/movie-banner.pipe.ts